import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import { adminGetAllStudent, adminGetAllStudents, adminDeleteStudent } from '../../../redux/action/adminAction';
import AdminHomeHelper from '../../../Components/AdminHomeHelper';
import classnames from 'classnames';
import Loading from '../../../Components/Loading';

const AdminGetAllFaculty = () => {
    const store = useSelector((store) => store);
    const dispatch = useDispatch();
    const [department, setDepartment] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [year, setYear] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState({});
    const history = useHistory();
    console.log(store.admin.allStudent)
    const formHandler = (e) => {
        e.preventDefault();
        setIsLoading(true);
        setTimeout(() => {
          setIsLoading(false);
        }, 3000);
        dispatch(adminGetAllStudent({ department, year }));
    }

    useEffect(() => {
        dispatch(adminGetAllStudents({}));
    }, []);
    useEffect(() => {
        const allStudentLength = store.admin.allStudent.length;
      
        if (allStudentLength !== 0) {
          setIsLoading(false);
        } else {
          const timeoutId = setTimeout(() => {
            setIsLoading(false);
          }, 3000);
      
          return () => clearTimeout(timeoutId);
        }
      }, [store.admin.allStudent.length]);

    const handleDeleteStudent = (studentId) => {
        console.log("Deleting student with ID: ", studentId);

        const shouldDelete = window.confirm("Are you sure you want to delete this student?");

        if (shouldDelete) {
            dispatch(adminDeleteStudent(studentId));

            alert("Student deleted successfully!");

            // Reload the page
            window.location.reload();
        }
    };
      
    const isDataAvailable = store.admin.allStudent && store.admin.allStudent.length > 0;
    const filteredStudents = store.admin.allStudent.filter((student) => {
      const searchFields = Object.values(student).map(value => value?.toString() || '');
        const normalizedQuery = searchQuery.toLowerCase().trim();
      
        return searchFields.some((field) => field.toLowerCase().includes(normalizedQuery));
      });

      const [displayedStudents, setDisplayedStudents] = useState(50);
  
      const loadMoreStudents = () => {
          setDisplayedStudents(displayedStudents + 50);
      };
  

    return (
        <div>
            {store.admin.isAuthenticated ? <>
              <div className="container-fluid p-0">
                <div className="d-flex">
                    <div className="print-helper">
                      <AdminHomeHelper />
                    </div>
                    <div className="mx-1 w-100 ">
                      <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                        <h3> <img src="/logo192.png" width={'50px'} alt="" /> OUR STUDENT'S</h3>
                        <button  onClick={()=> window.print()} type="button" className="print-helper btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
                      </div>
                        <div className="col d-md-flex align-items-center justify-content-between">
                            <form form-inline className='d-md-flex align-items-center justify-content-start' noValidate onSubmit={formHandler}>
                              <div className="form-group mx-2 print-helper">
                                <label htmlFor="departmentId">Department</label>
                                <select
                                  onChange={(e) => {
                                    if (e.target.value === "All") {
                                      dispatch(adminGetAllStudents({}));
                                      setSearchQuery('')
                                      setIsLoading(true);
                                      setTimeout(() => {
                                        setIsLoading(false);
                                      }, 3000);
                                    } else {
                                      setDepartment(e.target.value);
                                    }
                                  }}
                                  className={classnames("form-control", { 'is-invalid': error.department })}
                                  id="departmentId"
                                >
                                  <option>Select</option>
                                  <option value="All">All</option>
                                  <option value="ECE">ECE</option>
                                  <option value="CSE">CSE</option>
                                  <option value="EEE">EEE</option>
                                  <option value="AIDS">AIDS</option>
                                  <option value="MECH">MECH</option>
                                  <option value="CIVIL">CIVIL</option>
                                                <option value="BIO">BIO</option>
                                                <option value="AGRI">AGRI</option>
                                                <option value="MBA">MBA</option>
                                                <option value="MCA">MCA</option>
                                </select>
                                {error.department && (<div className="invalid-feedback">{error.department}</div>)}
                              </div>
                              <div className="form-group mx-2 print-helper">
                                    <label htmlFor="yearId">Year</label>
                                    <select onChange={(e) => setYear(e.target.value)} className={classnames("form-control",
                                        {
                                            'is-invalid': error.year
                                        })} id="yearId">
                                        <option>Select</option>
                                        <option value="I">1</option>
                                        <option value="II">2</option>
                                        <option value="III">3</option>
                                        <option value="IV">4</option>
                                    </select>
                                    {error.year && (<div className="invalid-feedback">{error.year}</div>)}
                                </div>
                              <div className="mt-3">
                                {!isLoading && <button type="submit" className="btn btn-info btn-block print-helper "><img src="/image/search.svg" className='mb-1' alt="" /> Search</button>}
                                {isLoading && (
                                  <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                  </div>
                                )}
                              </div>
                              <div className="form-group mx-2 print-helper">
                                <label htmlFor="searchQuery">Search</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="searchQuery"
                                  placeholder="Search by name, ID, department, etc."
                                  value={searchQuery}
                                  onChange={(e) => setSearchQuery(e.target.value)}
                                />
                              </div>
                            </form>
                            <button className='btn btn-success print-helper ' > <Link to="/admin/addStudent" className='text-light'> <img src="/image/add.svg" alt="" /> Student Registration</Link></button>
                      </div>
                      {isDataAvailable ? (
                <div className="col">
                    {store.admin.allStudent.length !== 0 && (
                        <table className="mt-3 table table-responsive table table-bordered table-striped-columns">
                                <thead>
                                    <tr className='bg-secondary text-light'>
                                        <th scope="col"width="5%">S.No</th>
                                        <th scope="col"width="10%">Photo</th>
                                        <th scope="col"width="15%">Registration Number</th>
                                        <th scope="col"width="20%">Name</th>
                                        <th scope="col"width="10%">Year</th>
                                        <th scope="col"width="10%">Department</th>
                                        <th scope="col"width="10%">Status</th>
                                        <th scope="col" width="20%" className="print-helper">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {filteredStudents.slice(0, displayedStudents).map((res, index) => (
                                            <tr key={index}>
                                                <th scope="row">{index + 1}</th>
                                                <td><img src={res.avatar} width={'50px'} style={{objectFit: 'cover',borderRadius:"50%",height:'50px',border:'2px solid #3D5356'}} alt="" /></td>
                                                <td>{res.registrationNumber}</td>
                                                <td>{res.name}</td>
                                                <td>{res.year}</td>
                                                <td>{res.department}</td>
                                                <td >
                                                <small className={`badge badge-${res.status === 'active' ? 'success' : res.status === 'irregular' ? 'warning' : 'danger'}`}>{res.status}</small></td>

                                                <td className="print-helper" style={{ whiteSpace: 'nowrap' }}>
                                                  <small className='bg-info text-light p-1 btn m-1'>
                                                    <Link to={`/admin/adminStudentView/${res._id}`} className='text-light'><img src="/image/view.svg" alt="" /> View</Link>
                                                  </small>
                                                  <small className='bg-success text-light p-1 btn m-1'>
                                                    <Link to={`/admin/adminStudentUpdate/${res._id}`} className='text-light'><img src="/image/edit.svg" alt="" /> Edit</Link>
                                                  </small>
                                                  <small className='bg-danger text-light p-1 btn m-1' onClick={() => handleDeleteStudent(res._id)}>
                                                    <img src="/image/delete.svg" alt="" /> Del
                                                  </small>
                                                </td>
                                            </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    )}
                
                                    {displayedStudents < filteredStudents.length && (
                                        <button onClick={loadMoreStudents} className=" m-3 btn btn-primary">
                                            Load More
                                        </button>
                                    )}
                                </div>
                        ) : (
                          <Loading />
                          )}
                        </div>
                    </div>
                </div>
            </> : (history.push('/'))}
        </div>
    )
}

export default AdminGetAllFaculty